import React from 'react';

import Modal from 'components/mweb/Modal/Modal';
import MultipleSkuBottomSheet from '../MultipleSku/MultipleSkuBottomSheet';

const MultipleSkuModal = ({ data = {}, onCancel = () => {} }) => {
  const { visible, data: product } = data;

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered={true}
      destroyOnClose={true}
      title="Select Packform"
      wrapClassName="bottom-sheet-multiple-sku"
    >
      <MultipleSkuBottomSheet product={product} />
    </Modal>
  );
};

export default MultipleSkuModal;
